import axios from 'axios'
import QS from 'qs'
import {
  Loading,
  Message
} from 'element-ui';
import router from '@/router/index'
import { convertCase } from '@/axios/util'

let excelAxios = axios.create({
  responseType: 'blob'
})

excelAxios.defaults.timeout = 30000;
let loading;

excelAxios.interceptors.request.use(config => {
  loading = Loading.service({
    fullscreen: true,
    background: 'rgba(255,255,255,.5)'
  });
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  let cah = localStorage.getItem("admin");
    let user;
    if (cah) {
      cah = convertCase(cah).split('').reverse().join('');
      user = QS.parse(atob(cah));
    }
  if (user && user.token !== undefined)
    config.headers['access_token'] = user.token;
  return config;
}, error => {
  loading.close();
  Message.error('网络错误')
})

excelAxios.interceptors.response.use(res => {
  loading.close();
  console.log(res);
  if (res.status === 200) {
    if (res.data.status !== undefined && res.data.status === 502) {
      router.push({path: '/'})
    }

    if(res.data.status !== undefined && res.data.status != 502 && res.data.status !== 200){
      Message.error(res.data.msg)
    }
    return res.data
  } else
    return Promise.reject("网络错误")
}, error => {
  loading.close();
  Message.error('网络错误')
})
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    excelAxios.post(url, QS.stringify(params)).then(res => {
      resolve(res)
    }, error => {
      reject(error);
    }).catch((error) => {
      reject(error)
    })
  })
}

export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    excelAxios.get(url, {
        params: param
      })
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/axios/excel.js